import { SendMailWithTemplateMeta, SendMailWithTemplatePayload } from 'types/store/SendMailWithTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { sendMailWithTemplateActions } from '../actions';

export default createAsyncReducer<SendMailWithTemplateMeta, SendMailWithTemplatePayload>(sendMailWithTemplateActions);
